export const getBodyDiff = (a, b) => {
    return Object.keys(a).reduce((diff, key) => {
        if (b[key] === a[key]) return diff;
        return {
            ...diff,
            [key]: a[key]
        };
    }, {});
};
